import {useCallback} from "react"
import {MetricDataTree} from "classes/MetricDataTree"

export const useGetMetricSeries = (parsedMetrics: MetricDataTree[]) => useCallback((metricNb: number, serieIndex: number) => {
  return metricNb < parsedMetrics.length ? parsedMetrics[metricNb].getSeries()[serieIndex] : undefined
}, [parsedMetrics])